import { useUserQuery } from '../../user/useUserQuery';

type HookValue = {
  isDataCreditsEnabled: boolean;
  isLoading: boolean;
};

export const useIsDataCreditsEnabled = (): HookValue => {
  const { data: user, isLoading } = useUserQuery();

  return {
    isDataCreditsEnabled: user?.isDataCreditsEnabled ?? false,
    isLoading,
  };
};
